import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import routes from "../../Helpers/Routes.json";
import { useTranslation } from "react-i18next";
import { HiOutlineCheckCircle } from "react-icons/hi";

function PaymentSuccessPage() {
  const params = useParams();
  const { t } = useTranslation();

  return (
    <Container className="py-5 text-center" style={{ maxWidth: "500px" }}>
      <div className="card p-5">
        <HiOutlineCheckCircle
          size={64}
          className="mb-3"
          style={{ color: "var(--tws-success)" }}
        />
        <h2 className="h3 fw-bold mb-2">
          {t("¡Hemos recibido tu pedido!")}
        </h2>
        <p className="text-muted mb-1">
          {t("Empezaremos a prepararlo enseguida")}{" "}
          <span aria-label="smile" role="img">
            😊
          </span>
        </p>
        <p className="small text-muted mb-4">
          {t("Pedido #{{order}}", { order: params.transaction })}
        </p>

        <div className="d-flex gap-2 justify-content-center">
          <Link
            to={routes.Homepage.index}
            className="btn btn-dark rounded-pill"
          >
            {t("Volver")}
          </Link>
          <Link
            to={routes.OrdersPage.detail.replace(":order", params.transaction)}
            className="btn btn-outline-secondary rounded-pill"
          >
            {t("Ver el pedido")}
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default PaymentSuccessPage;
